import environment from "../../environment/environment";

export default class SensorsUtils {
    static getBackgroundSensor(cropType){
        switch (cropType) {
            case 'Flores':
                return environment.roses;
            case 'Aguacate':
                return environment.avocado;
            case 'Café':
                return environment.coffee;
            case 'Palma':
                return environment.palm;
            case 'Tomate':
                return environment.tomatoes;
            case 'Gulupa':
                return environment.gulupa;
            case 'Arándanos':
                return environment.blueberries;
            case 'Aromáticas':
                return environment.peppermint;
            default:
                return environment.plants;
        }
    }
}